// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thumb[data-v-48455a97]{border-radius:1px;background:#fff;border:1px solid #f0f0f0;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 2px rgba(0,0,0,.6);box-shadow:0 0 2px rgba(0,0,0,.6);z-index:10}.filter[data-v-48455a97],.thumb[data-v-48455a97]{position:absolute}.filter[data-v-48455a97]{top:0;right:0;bottom:0;left:0}", ""]);
// Exports
module.exports = exports;
